import {
    Box,
    Button,
    Card,
    CardActions,
    CardContent,
    Checkbox,
    FormControl,
    FormControlLabel,
    FormGroup,
    FormLabel,
    Grid,
    InputLabel,
    TextField,
    Typography
} from '@mui/material';
import { useEffect, useState } from 'react';
import { Controller, useForm } from 'react-hook-form';
import { useNavigate, useParams } from 'react-router-dom';
import { apiService } from '../../api/axiosClient';
import Page from '../../components/Page';
import { InputCurrencyMask } from '../../components/input-numbers';
import CustomChip from '../../components/mui/chip';
import FileUploaderSingle from '../../components/upload/FileUploaderSingle';
import DropzoneWrapper from '../../styles/react-dropzone';
import { convertURLtoFile } from '../../utils/convertURLtoFile';
import { getIcon } from '../../utils/hex-to-rgba';

const Product = () => {
    const params = useParams();
    const navigate = useNavigate();
    const [product, setProduct] = useState();
    const [files, setFiles] = useState([]);
    const {
        control,
        formState: { errors },
        reset,
    } = useForm()

    useEffect(() => {
        const fetchData = async () => {
            const response = await apiService.get(`/products/${params.id}`)
            const payload = response.data;

            setProduct(payload.data)
        }

        fetchData().catch(e => console.error(e));
    }, [params.id]);

    useEffect(() => {
        convertURLtoFile(getIcon(product?.icon1), setFiles)
    }, [product?.icon1]);

    useEffect(() => {
        reset({
            sku: product?.sku,
            name: product?.name,
            keywords: product?.keywords,
            category: product?.category1 + ' > ' + product?.category2 + ' > ' + product?.category3,
            brand: product?.brand,
            price: product?.price,
            sale_price: product?.sale_price,
            stock_kor: product?.stock_kor,
            stock_intl: product?.stock_intl,
            brandnew: product?.attrib?.includes('brandnew') || false,
            best: product?.attrib?.includes('best') || false,
            sale: product?.attrib?.includes('sale') || false,
            it_use: product?.it_use,
            soldout: product?.it_soldout,
        })

    }, [reset, product]);

    const goBack = () => {
        navigate(-1)
    }

    return (
        <Page title="Product">
            <Card>                
                <CardContent sx={{ pt: 8 }}>
                    <Box sx={{ mb: 9, textAlign: 'center' }}>
                        <Typography variant='h5' sx={{ mb: 3, lineHeight: '2rem' }}>
                            제품
                        </Typography>
                    </Box>

                    <Grid container spacing={6}>
                        <Grid item xs={12} md={6}>
                            <FormControl fullWidth>
                                <Controller
                                    name='sku'
                                    control={control}
                                    defaultValue=""
                                    render={({ field: { value, onChange } }) => (
                                        <TextField
                                            value={value}
                                            disabled
                                            label='SKU'
                                            id='sku'
                                            onChange={onChange}
                                            placeholder='이름을 입력해주세요'
                                            error={Boolean(errors.sku)}
                                            aria-describedby='validation-async-sku'
                                        />
                                    )}
                                />
                            </FormControl>
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <FormControl fullWidth>
                                <Controller
                                    name='category'
                                    control={control}
                                    defaultValue=""
                                    render={({ field: { value, onChange } }) => (
                                        <TextField
                                            value={value}
                                            disabled
                                            label='카테고리'
                                            id='category'
                                            onChange={onChange}
                                            placeholder='이름을 입력해주세요'
                                            error={Boolean(errors.category)}
                                            aria-describedby='validation-async-category'
                                        />
                                    )}
                                />
                            </FormControl>
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <FormControl fullWidth>
                                <Controller
                                    name='name'
                                    control={control}
                                    rules={{ required: true }}
                                    defaultValue=""
                                    render={({ field: { value, onChange } }) => (
                                        <TextField
                                            value={value}
                                            label='이름'
                                            id='name'
                                            onChange={onChange}
                                            placeholder='이름을 입력해주세요'
                                            error={Boolean(errors.name)}
                                            helpertext={errors?.message}
                                            aria-describedby='validation-async-name'
                                        />
                                    )}
                                />
                            </FormControl>
                        </Grid>

                        <Grid item xs={12} md={6}>
                            <FormControl fullWidth>
                                <Controller
                                    name='brand'
                                    control={control}
                                    rules={{ required: true }}
                                    defaultValue=""
                                    render={({ field: { value, onChange } }) => (
                                        <TextField
                                            value={value}
                                            label='브랜드'
                                            id='brand'
                                            onChange={onChange}
                                            placeholder='브랜드를 입력해주세요'
                                            error={Boolean(errors.brand)}
                                            helpertext={errors?.message}
                                            aria-describedby='validation-async-brand'
                                        />
                                    )}
                                />
                            </FormControl>
                        </Grid>

                        <Grid item xs={12} md={6}>
                            <FormControl fullWidth>
                                <InputLabel htmlFor="price">단가</InputLabel>
                                <Controller
                                    name='price'
                                    control={control}
                                    rules={{ required: true }}
                                    defaultValue=""
                                    render={({ field: { value, onChange } }) => (
                                        <InputCurrencyMask                                                
                                            value={value}
                                            label='단가'
                                            id='price'
                                            onChange={onChange}
                                            placeholder='단가를 입력해주세요'
                                            error={Boolean(errors.price)}
                                            helpertext={errors?.message}
                                        />
                                    )}
                                />
                            </FormControl>
                        </Grid>

                        <Grid item xs={12} md={6}>
                            <FormControl fullWidth>
                                <InputLabel htmlFor="price">판매가</InputLabel>
                                <Controller
                                    name='sale_price'
                                    control={control}
                                    rules={{ required: true }}
                                    defaultValue=""
                                    render={({ field: { value, onChange } }) => (
                                        <InputCurrencyMask
                                            value={value}
                                            label='판매가'
                                            id='sale_price'
                                            onChange={onChange}
                                            placeholder='판매가를 입력해주세요'
                                            error={Boolean(errors.sale_price)}
                                            helpertext={errors?.message}
                                            aria-describedby='validation-async-sale_price'
                                        />
                                    )}
                                />
                            </FormControl>
                        </Grid>

                        <Grid item xs={12} md={6}>
                            <FormControl fullWidth>
                                <Controller
                                    name='stock_kor'
                                    control={control}
                                    rules={{ required: true }}
                                    defaultValue=""
                                    render={({ field: { value, onChange } }) => (
                                        <TextField
                                            value={value}
                                            label='국내 재고수량'
                                            id='stock_kor'
                                            onChange={onChange}
                                            placeholder='재고수량를 입력해주세요'
                                            error={Boolean(errors.stock_kor)}
                                            helpertext={errors?.message}
                                            aria-describedby='validation-async-stock_kor'
                                        />
                                    )}
                                />
                            </FormControl>
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <FormControl fullWidth>
                                <Controller
                                    name='stock_intl'
                                    control={control}
                                    rules={{ required: true }}
                                    defaultValue=""
                                    render={({ field: { value, onChange } }) => (
                                        <TextField
                                            value={value}
                                            label='해외 재고수량'
                                            id='stock_intl'
                                            onChange={onChange}
                                            placeholder='재고수량를 입력해주세요'
                                            error={Boolean(errors.stock_intl)}
                                            helpertext={errors?.message}
                                            aria-describedby='validation-async-stock_intl'
                                        />
                                    )}
                                />
                            </FormControl>
                        </Grid>

                        <Grid item xs={12}>
                            <FormControl fullWidth>
                            <Controller
                                name='keywords'
                                control={control}
                                rules={{ required: true }}
                                defaultValue=""
                                render={({ field: { value, onChange } }) => (
                                <TextField
                                    value={value}
                                    label='태그'
                                    id='keywords'
                                    onChange={onChange}
                                    placeholder='짭은 이름을 입력해주세요'
                                    error={Boolean(errors.reply)}
                                    helpertext={errors?.message}
                                    aria-describedby='validation-async-keywords'
                                />
                                )}
                            />
                            </FormControl>
                        </Grid>

                        <Grid item xs={6}>
                            <FormControl>
                                <FormLabel>상품속성</FormLabel>
                                <FormGroup row>
                                    <Controller
                                        name='brandnew'
                                        control={control}
                                        rules={{ required: false }}
                                        defaultValue={false}
                                        render={({ field: { value, onChange } }) => (
                                            <FormControlLabel
                                                label='신상품'
                                                control={
                                                    <Checkbox checked={value} onChange={onChange} name='controlled' />
                                                }
                                            />
                                        )}
                                    />
                                    <Controller
                                        name='best'
                                        control={control}
                                        rules={{ required: false }}
                                        defaultValue={false}
                                        render={({ field: { value, onChange } }) => (
                                            <FormControlLabel
                                                label='베스트'
                                                control={
                                                    <Checkbox checked={value} onChange={onChange} name='controlled' />
                                                }
                                            />
                                        )}
                                    />
                                    <Controller
                                        name='sale'
                                        control={control}
                                        rules={{ required: false }}
                                        defaultValue={false}
                                        render={({ field: { value, onChange } }) => (
                                            <FormControlLabel
                                                label='세일'
                                                control={
                                                    <Checkbox checked={value} onChange={onChange} name='controlled' />
                                                }
                                            />
                                        )}
                                    />
                                </FormGroup>
                            </FormControl>
                        </Grid>

                        <Grid item xs={6}>
                            <FormControl>
                                <FormLabel>상품표시</FormLabel>
                                <FormGroup row>
                                    <Controller
                                        name='soldout'
                                        control={control}
                                        rules={{ required: false }}
                                        defaultValue={false}
                                        render={({ field: { value, onChange } }) => (
                                            <FormControlLabel
                                                label='SOLDOUT'
                                                control={
                                                    <Checkbox checked={value} onChange={onChange} name='controlled' />
                                                }
                                            />
                                        )}
                                    />
                                    <Controller
                                        name='it_use'
                                        control={control}
                                        rules={{ required: false }}
                                        defaultValue={false}
                                        render={({ field: { value, onChange } }) => (
                                            <FormControlLabel
                                                label='상품노출'
                                                control={
                                                    <Checkbox checked={value} onChange={onChange} name='controlled' />
                                                }
                                            />
                                        )}
                                    />
                                </FormGroup>
                            </FormControl>
                        </Grid>

                        <Grid item xs={12}>
                            <DropzoneWrapper>
                                <FileUploaderSingle files={files} setFiles={setFiles} readonly={true}/>
                            </DropzoneWrapper>
                        </Grid>

                        <Grid item xs={12}>
                            <CustomChip
                                skin='light'
                                color='info'
                                label={`등록날짜: ${product?.insert_time}`}
                                sx={{ '& .MuiChip-label': { color: 'common.black' } }}
                            />
                        </Grid>
                    </Grid>
                </CardContent>

                <CardActions className='card-action'>
                    <Button variant='contained' onClick={goBack}> OK </Button>
                </CardActions>
            </Card>
        </Page>
    )
}

export default Product